import React, {useEffect} from 'react';

export const ThrowErrorPage: React.FC = () => {
  useEffect(() => {
    throw Error('Testing error page');
  }, []);
  return <>showing error</>;
};
